import { render, staticRenderFns } from "./AlarmTimer.vue?vue&type=template&id=0b4d6672"
import script from "./AlarmTimer.vue?vue&type=script&lang=js"
export * from "./AlarmTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports